import React from 'react';
import PidDiagramShell, { PidPipe, PidPort } from './PidDiagramShell';
import { OlefinRoute } from '../../types';

/** 甲醇制丙烯（MTP）P&ID 详细图：甲醇预热 → 两段固定床反应器 → 急冷压缩 → 丙烯精馏 */
const media = {
  meth: { label: '甲醇', light: '#00838f', dark: '#4dd0e1', width: 2.6 },
  gas: { label: '反应气 / 丙烯', light: '#2e7d32', dark: '#81c784', width: 2.6 },
  water: { label: '水 / 急冷水', light: '#1565c0', dark: '#64b5f6', width: 2 },
};

const devices = [
  { id: 'e101', kind: 'exchanger' as const, x: 100, y: 181, tag: 'E-101', name: '甲醇预热' },
  { id: 'r101', kind: 'reactor' as const, x: 260, y: 128, tag: 'R-101', name: 'MTP反应器一', note: '470℃' },
  { id: 'r102', kind: 'reactor' as const, x: 430, y: 128, tag: 'R-102', name: 'MTP反应器二' },
  { id: 't101', kind: 'column' as const, x: 600, y: 101, tag: 'T-101', name: '急冷塔' },
  { id: 'c101', kind: 'compressor' as const, x: 760, y: 193, tag: 'C-101', name: '反应气压缩机' },
  { id: 't102', kind: 'column' as const, x: 910, y: 101, tag: 'T-102', name: '脱乙烷塔' },
  { id: 't103', kind: 'column' as const, x: 1050, y: 101, tag: 'T-103', name: '丙烯精馏塔' },
];

const ports: PidPort[] = [
  { id: 'p-meth', label: '甲醇', medium: 'meth', x: 0, y: 224, direction: 'in' as const },
  { id: 'p-propylene', label: '丙烯', medium: 'gas', x: 1310, y: 611, direction: 'out' as const },
  { id: 'p-tail', label: '甲烷/乙烷尾气', medium: 'gas', x: 1160, y: 52, direction: 'out' as const },
  { id: 'p-gasoline', label: '副产汽油', medium: 'meth', x: 1000, y: 470, direction: 'out' as const },
];

const pipes: PidPipe[] = [
  { id: 's01', from: 'p-meth', fromSide: 'right', to: 'e101', toSide: 'left', medium: 'meth' },
  { id: 's02', from: 'e101', fromSide: 'right', to: 'r101', toSide: 'left', medium: 'meth' },
  { id: 's03', from: 'r101', fromSide: 'right', to: 'r102', toSide: 'left', medium: 'gas' },
  { id: 's04', from: 'r102', fromSide: 'right', to: 't101', toSide: 'left', medium: 'gas' },
  { id: 's05', from: 't101', fromSide: 'right', to: 'c101', toSide: 'left', medium: 'gas' },
  { id: 's06', from: 'c101', fromSide: 'right', to: 't102', toSide: 'left', medium: 'gas' },
  { id: 's07', from: 't102', fromSide: 'right', to: 't103', toSide: 'left', medium: 'gas' },
  { id: 's08', from: 't103', fromSide: 'bottom', to: 'p-propylene', toSide: 'left', medium: 'gas' },
  { id: 's09', from: 't102', fromSide: 'top', to: 'p-tail', toSide: 'left', medium: 'gas' },
  { id: 's10', from: 't101', fromSide: 'bottom', to: 'p-gasoline', toSide: 'left', medium: 'meth' },
];

const MtpDiagram: React.FC<{ route: OlefinRoute }> = ({ route }) => (
  <PidDiagramShell
    routeName={route.name}
    title="MTP 装置详细流程"
    subtitle="甲醇预热 → 两段固定床反应器（ZSM-5 分子筛，470℃）→ 急冷 → 压缩 → 脱乙烷 → 丙烯精馏，副产汽油从急冷塔底外送（设备形状按 P&ID 惯例，管线按介质分色）"
    media={media}
    devices={devices}
    ports={ports}
    pipes={pipes}
    feedstock={route.feedstock}
    products={[...route.products, ...(route.byproducts ?? [])]}
  />
);

export default MtpDiagram;
